<template>
  <div>
  <div v-if="submissionUuid && access && feedback" v-for="(feedback, index) in feedbacks" class="comment-wrapper">
    <div class="title">Feedback:</div>
    <div class="content">
    <md-card>

      <!-- <md-card-header class="text-left">
        <div class="md-title">Feedback</div>
      </md-card-header> -->

      <md-card-content class="text-left">
        <div v-html="rendered[index]"></div>
      </md-card-content>
    </md-card>
    </div>
  </div>
  </div>
</template>


<script>
export default {
  name: "Feedback",
  props: ["submission-uuid", "user-uuid", "submission-view-mode"],
  mounted() {
    this.getFeedback();
  },
  computed: {
    access() {
      if (
        this.feedback != "" &&
        window.drupalSettings.user.role == "learner_reviewer"
      ) {
        if (this.submissionViewMode) {
          return true;
        }
        let nuuid = Object.keys(window.drupalSettings.form_builder)[0];
        let submission =
          window.drupalSettings.form_builder[nuuid].submissions[
            this.submissionUuid
          ];

        if (
          submission.status == 1 ||
          submission.status == this.$status.ACTIVITY_REVIEW_NEEDED ||
          submission.status == this.$status.ACTIVITY_NEEDS_WORK ||
          submission.status == this.$status.ACTIVITY_COMPLETED
        ) {
          return true;
        }
      }
      if (
        window.drupalSettings.user.role == "coach" ||
        window.drupalSettings.user.role == "administrator"
      ) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      feedbacks: [],
      rendered: [],
      feedbackFormat: 'client_full_html',
    };
  },
  methods: {
    async renderHtml(htmlData) {
      if (!htmlData) {
        return '';
      }
      const response = await this.getToken().then((token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/json");
        fetch_headers.append("X-CSRF-Token", token);
        return fetch("/api/v1/render-html", {
          credentials: "include",
          method: "POST",
          headers: fetch_headers,
          dataType: "json",
          body: JSON.stringify({
            text: htmlData,
            format: this.feedbackFormat,
          }),
        });
      });
      return await response.text();
    },
    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include"
      })
        .then(response => {
          return response.text();
        })
        .then(text => {
          return text;
        });
    },
    getFeedback() {
      this.getToken().then(token => {
          let fetch_headers = new Headers();
          fetch_headers.append("Content-Type", "application/vnd.api+json");
          fetch_headers.append("X-CSRF-Token", token);
          let requestUrl = "/jsonapi/catch_comment/catch_comment?" +
            "filter[element_uuid][condition][path]=element_uuid" +
            "&filter[element_uuid][condition][operator]=IS NULL" +
            "&filter[submission_uuid]=" + this.submissionUuid;
          if (this.userUuid) {
            requestUrl +=  "&filter[user.id][value]=" + this.userUuid;
          }
          return fetch(requestUrl,
            {
              credentials: "include",
              method: "GET",
              headers: fetch_headers
            }
          )
            .then(response => {
              return response.json();
            })
            .then(json => {
              this.feedbacks = json.data.length ? json.data : [];
            })
            .then(() => {
              this.feedbacks.forEach(async (f) => {
                let htmlData = f.attributes.comment.value;
                this.rendered.push(await this.renderHtml(htmlData));
              });
            });
        });
      },
  }
};
</script>
<style lang="scss">
.comment-wrapper .md-card .md-card-header .md-title {
    font-family: "filson-soft", sans-serif;
    font-size: 20px;
    font-weight: bold;
    margin: 0;
}
</style>
